import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { FieldArray } from '~src/settings/FormikWrapperForStubbing';
import { cssClass } from '~src/style';

import { LoadingDataSpinner } from '../LoadingDataSpinner';
import { Domain } from '../types/Domain';
import { UserDefinedPoolModel } from '../types/PoolModel';
import { DataConnectMultiPoolTableEntryDomains } from './DataConnectMultiPoolTableEntryDomains';
import { DataConnectMultiPoolTableEntryPool } from './DataConnectMultiPoolTableEntryPool';
import { ExpandPoolButton } from './ExpandPoolButton';

export type DataConnectMultiPoolTableBodyProps = Readonly<{
  pools: Record<string, UserDefinedPoolModel>;
  bridgeDomains: Record<string, Domain>;
  existingPoolNames: ReadonlyArray<string>;
  siteId: string;
  refreshPoolsAndClusters: () => void;
  hasLoadedPoolsAndClusters: boolean;
}>;

export function DataConnectMultiPoolTableBody(props: DataConnectMultiPoolTableBodyProps) {
  const [expandedRowIndex, setExpandedRowIndex] = React.useState(-1);

  const pools: ReadonlyArray<UserDefinedPoolModel> = Object.values(props.pools);

  if(!props.hasLoadedPoolsAndClusters) {
    return LoadingDataSpinner();
  }

  if (pools.length === 0) {
    return renderNoPoolsWarning();
  }

  return (
    <FieldArray
      name={''}
      render={() => (
        pools.map((pool: UserDefinedPoolModel, index) => (
          <tbody key={index}>
            <tr>
              <ExpandPoolButton
                isExpanded={expandedRowIndex === index}
                setExpanded={(expand: boolean) => setExpandedRowIndex(expand ? index : -1)}
                isDisabled={false}
              />
              <DataConnectMultiPoolTableEntryPool
                pool={pool}
                existingPoolNames={props.existingPoolNames}
                isExpanded={expandedRowIndex === index}
                siteId={props.siteId}
                userDefinedPools= {props.pools}
                bridgeDomains={props.bridgeDomains}
                refreshPoolsAndClusters={props.refreshPoolsAndClusters}
              />
            </tr>
            {(expandedRowIndex === index) &&
              <tr className={focusClass}>
                <td className={'tb-data-grid-separator-row'} style={{borderBottom: 0}} />
                <td colSpan={7}>
                  <DataConnectMultiPoolTableEntryDomains
                    domains={Object.values(pool.domains)}
                    poolId={pool.poolId}
                    poolName={pool.displayName}
                    siteId={props.siteId}
                    userDefinedPools= {props.pools}
                    bridgeDomains={props.bridgeDomains}
                    refreshPoolsAndClusters={props.refreshPoolsAndClusters}
                  />
                </td>
              </tr>}
          </tbody>))
      )}
    />
  );
}

function renderNoPoolsWarning() {
  return (
    <tbody>
      <tr>
        <td colSpan={9}>
          <div className={'tb-data-grid-cell-text tb-data-grid-DataConnect-center'}>
            {Messages.dataConnectSiteSettingsPoolNotFoundWarning()}
          </div>
        </td>
      </tr>
    </tbody>);
}

const focusClass = cssClass('MultiPool', 'expanded-focus', {
  background: 'rgba(255, 255, 255, 0.00)',
});
